import ProfileQuery from 'queries/user/header';
import useResourceShow from 'hooks/use_resource_show';

const useUserHeader = () => {
  const { data, loading } = useResourceShow({
    query: ProfileQuery,
    fetchPolicy: 'cache-first',
    errorKey: 'error.user.profile.show',
    defaultData: { user: { email: '...' }, space: { id: null, name: '', adminRole: false } },
  });

  return {
    user: data.user,
    space: data.space,
    loading,
  };
};

export default useUserHeader;
